export default "__VITE_ASSET__DmRtICov__"